/**
 * Authentication Helper Utility
 * Provides functions to check user authentication status
 */

/**
 * Check if user is authenticated (logged in)
 * @returns {boolean} true if user is logged in, false otherwise
 */
export const isAuthenticated = () => {
  try {
    const loginDetails = localStorage.getItem('loginDetails');
    if (!loginDetails || loginDetails === 'null' || loginDetails === 'undefined') {
      return false;
    }
    const parsed = JSON.parse(loginDetails);
    return !!(parsed && parsed[0] && parsed[0].token);
  } catch (error) {
    console.error('Error checking authentication:', error);
    return false;
  }
};

/**
 * Get current user token
 * @returns {string|null} token if exists, null otherwise
 */
export const getAuthToken = () => {
  try {
    const loginDetails = localStorage.getItem('loginDetails');
    if (!loginDetails || loginDetails === 'null' || loginDetails === 'undefined') {
      return null;
    }
    const parsed = JSON.parse(loginDetails);
    return parsed?.[0]?.token || null;
  } catch (error) {
    console.error('Error getting auth token:', error);
    return null;
  }
};

export default {
  isAuthenticated,
  getAuthToken,
};
